var map = {
	"./HALLAM/config": "be71",
	"./HALLAM/config.js": "be71",
	"./HALLAM/logo/logo-english.png": "919a",
	"./MC/config": "9771",
	"./MC/config.js": "9771",
	"./MC/logo/footer-log.png": "ac6b",
	"./MC/logo/footer-logo.png": "215a",
	"./MC/logo/logo-arabic.png": "b80b",
	"./MC/logo/logo-english.png": "95c3",
	"./PYLON/config": "a3d8",
	"./PYLON/config.js": "a3d8",
	"./PYLON/logo/footer-logo.png": "1220"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10fe";